<template>
  <div class="doctor-list">
    <modal
      ref="deleteDoctor"
      template="question"
      title="Aviso"
      ref-name="deleteDoctor"
      first-button-text="Cancelar"
      second-button-text="Excluir"
      @first-cta="closeModal()"
      @second-cta="handleDelete()"
    >
      <p>Tem certeza que deseja excluir o médico?</p>
      <div class="doctor-list__modal-text">
        <span v-html="selectedItem ? selectedItem.name : ''" />
      </div>
    </modal>

    <InfiniteLoading
      v-if="filteredArray && filteredArray.length > 0"
      :list="filteredArray"
      :items-per-scroll="20"
      @load-more="loadMore"
      @update-list="updateList"
    />

    <div
      v-if="doctorIsLoading"
      class="loading"
    >
      <spinner />
    </div>
    <div v-else>
      <data-table
        v-if="filteredArray && filteredArray.length > 0"
        :header="table.header"
        is-sticky
      >
        <div
          v-for="(doctor, index) in listItems"
          :key="index"
          class="data-table__body__row"
        >
          <data-cell :size="40">
            <p class="name ellipsable">
              {{ doctor.name }}
              <md-tooltip md-direction="top">
                {{ doctor.name }}
              </md-tooltip>
            </p>
          </data-cell>

          <data-cell :size="20">
            <p class="regular ellipsable">
              {{ doctor.crm }}
              <md-tooltip md-direction="top">
                {{ doctor.crm }}
              </md-tooltip>
            </p>
          </data-cell>

          <data-cell :size="20">
            <p class="regular ellipsable">
              {{ doctor.uf }}
              <md-tooltip md-direction="top">
                {{ doctor.uf }}
              </md-tooltip>
            </p>
          </data-cell>

          <data-cell
            :size="20"
            class="actions-cell"
          >
            <div class="actions-container">
              <!-- edit action -->
              <div
                class="status-icon icon-edit-alt"
                @click="handleEdit(doctor)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Editar
                </md-tooltip>
              </div>

              <!-- delete action -->
              <div
                id="delete"
                class="status-icon icon-delete-alt"
                @click="openDeleteModal(doctor)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Excluir
                </md-tooltip>
              </div>
            </div>
          </data-cell>
        </div>
      </data-table>
      <div
        v-if="filteredArray && filteredArray.length === 0 && !doctorIsLoading"
        class="no-results"
      >
        <div class="img-wrapper">
          <img
            src="/static/images/no-file-img.svg"
            alt="sem-resultados"
          >
        </div>
        <p>Nenhum médico cadastrado.</p>
        <p>Para adicionar médicos, selecione:</p>
        <button @click="$router.push('/doctor/new')">
          NOVO MÉDICO
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../common/dataTable/DataTable'
import DataCell from '../common/dataTable/DataCell'
import Spinner from '@/components/common/Spinner'
import InfiniteLoading from '@/components/common/InfiniteLoading'
import { mapActions, mapGetters } from 'vuex'
import fuzzysort from 'fuzzysort'

export default {
  name: 'DoctorList',
  components: {
    DataTable,
    DataCell,
    InfiniteLoading,
    Spinner
  },
  props: {
    filterInput: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      selectedItem: null,
      table: {
        header: [
          {
            title: 'Médico',
            subtitle: 'Nome',
            size: 40
          },
          {
            title: 'CRM',
            subtitle: '',
            size: 20
          },
          {
            title: 'UF',
            subtitle: '',
            size: 20
          },
          {
            title: '',
            subtitle: '',
            size: 20
          }
        ]
      },
      listItems: []
    }
  },
  methods: {
    ...mapActions(['getDoctors']),
    ...mapActions(['doctorDelete']),
    closeModal () {
      this.$refs.deleteDoctor.close()
    },
    openDeleteModal (item) {
      this.selectedItem = item
      this.$refs.deleteDoctor.open()
    },
    handleEdit (doctor) {
      this.$router.push({
        path: '/doctor/edit/' + doctor.id_doctor
      })
    },
    handleDelete () {
      this.doctorDelete(this.selectedItem)
      this.closeModal()
    },
    updateList (newList) {
      this.listItems = newList
    },
    loadMore (items) {
      items.forEach((item) => {
        this.listItems.push(item)
      })
    }
  },
  computed: {
    ...mapGetters(['doctorIsLoading']),
    ...mapGetters(['doctorList']),
    filteredArray: {
      get () {
        if (this.filterInput) {
          if (this.filterInput.length > 0) {
            let result = fuzzysort.go(this.filterInput, this.doctorList, {
              keys: ['name', 'uf', 'crm'],
              limit: 100,
              allowTypo: true,
              threshold: -10000
            })
            result = result.map((item) => {
              item = item.obj
              return item
            })
            return result
          }
        } else {
          return this.doctorList
        }
      },
      set (newVal) {
        return newVal
      }
    }
  },
  mounted () {
    this.getDoctors()
  }
}
</script>

<style lang="scss">
.doctor-list {
  margin-bottom: 40px;
  width: 100%;

  .actions-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__modal-text {
    text-align: center;
    padding: 15px;
    background: #f5f5f5;
    border-radius: 5px;

    span {
      font-weight: 500;
      font-size: 16px;
      color: #4a4a4a;
      letter-spacing: 0;
    }
  }

  &__show-detail {
    min-height: 58px;
    cursor: pointer;
  }

  .data-table {
    &__header {
      &__row {
        height: auto !important;
        &--sticky {
          height: 50px !important;
          display: flex;
          align-items: flex-end;
          padding-bottom: 10px;
        }
        &__cell {
          padding: 0 16px !important;
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          margin-bottom: 5px;
        }
      }
    }
    &__body {
      &__row {
        width: 100%;
        min-height: auto !important;
        cursor: pointer;
        margin-bottom: 8px;
        box-shadow: 0px 1px 4px rgba(121, 121, 121, 0.12);

        &__cell {
          padding: 0 16px;

          p {
            cursor: pointer;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 26px;
            padding: 16px 0;
          }
        }
      }
    }
  }
  .actions-cell {
    padding: 0 !important;
  }

  &__detail-row {
    line-height: 26px;
    &--active {
      transform: rotate(180deg);
    }
  }

  .loading {
    min-height: 60vh;
    display: flex;
    align-items: center;
  }

  .no-results {
    color: #7a7a7a;
    text-align: center;
    min-height: 70vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column;
    .img-wrapper {
      margin-bottom: 35px;
    }
    p {
      font-size: 16px;
      margin-bottom: 20px;
      &:first-of-type {
        font-size: 20px;
      }
    }
    button {
      font-size: 10px;
      color: #fff;
      font-weight: 500;
      background-color: #55cd9e;
      padding: 8px 16px;
      height: auto;
      margin: 10px 0;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  .infinite-loading-container {
    min-height: 30vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ellipsable {
    font-size: 14px;
    text-transform: none;
    width: 100%;
    color: #4A4A4A;
  }
  .name {
    font-style: normal;
    font-weight: 500;
  }
  .regular {
    font-weight: normal;
  }

  .regular {
    font-weight: normal;
    font-size: 14px;
  }

  .actions {
    &-container {
      .icon-delete-alt,
      .icon-edit-alt {
        opacity: 0;
      }
      div {
        margin: 0 0.4em;
      }
    }
    &-cell {
      padding-left: 0;
    }
  }

  .data-table__body__row {
    min-height: 5.5em;
    &__cell {
      display: flex;
    }
    &:hover {
      .actions {
        &-container {
          .icon-delete-alt,
          .icon-edit-alt {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
